module.exports = __webpack_public_path__ + "static/media/general-cams.7fca8b0e.xlsx";